// extracted by mini-css-extract-plugin
module.exports = {"footer":"_b8dcada","button":"_b1b6cf0"};